/* eslint-disable */
// AUTO-GENERATED by scripts/fetch-ticker-data.mjs — do not edit.
export interface TickerIndexEntry {
  ticker: string;
  name: string;
  sector: string;
  exchange: string;
  logoUrl: string;
  accent: string;
}
export const tickerIndex: TickerIndexEntry[] = [
  {
    "ticker": "AAPL",
    "name": "Apple Inc.",
    "sector": "Electronic Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/apple.svg",
    "accent": "#000000"
  },
  {
    "ticker": "ABBV",
    "name": "AbbVie, Inc.",
    "sector": "Health Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/abbvie.svg",
    "accent": "#071D49"
  },
  {
    "ticker": "ABNB",
    "name": "Airbnb, Inc. Class A",
    "sector": "Consumer Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/airbnb.svg",
    "accent": "#FF5A5F"
  },
  {
    "ticker": "ABT",
    "name": "Abbott Laboratories",
    "sector": "Health Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/abbott.svg",
    "accent": "#009CDE"
  },
  {
    "ticker": "ACN",
    "name": "Accenture Plc Class A",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/accenture.svg",
    "accent": "#A100FF"
  },
  {
    "ticker": "ADBE",
    "name": "Adobe Inc.",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/adobe.svg",
    "accent": "#FA0F00"
  },
  {
    "ticker": "AMD",
    "name": "Advanced Micro Devices, Inc.",
    "sector": "Electronic Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/advanced-micro-devices.svg",
    "accent": "#ED1C24"
  },
  {
    "ticker": "AMGN",
    "name": "Amgen Inc.",
    "sector": "Health Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/amgen.svg",
    "accent": "#0063A3"
  },
  {
    "ticker": "AMT",
    "name": "American Tower Corporation",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/american-tower.svg",
    "accent": "#009CDE"
  },
  {
    "ticker": "AMZN",
    "name": "Amazon.com, Inc.",
    "sector": "Retail Trade",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/amazon.svg",
    "accent": "#FF9900"
  },
  {
    "ticker": "AVGO",
    "name": "Broadcom Inc.",
    "sector": "Electronic Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/broadcom.svg",
    "accent": "#CC092F"
  },
  {
    "ticker": "AXP",
    "name": "American Express Company",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/american-express.svg",
    "accent": "#006FCF"
  },
  {
    "ticker": "BA",
    "name": "Boeing Company",
    "sector": "Electronic Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/boeing.svg",
    "accent": "#0033A0"
  },
  {
    "ticker": "BAC",
    "name": "Bank of America Corp",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/bank-of-america.svg",
    "accent": "#012169"
  },
  {
    "ticker": "BKNG",
    "name": "Booking Holdings Inc.",
    "sector": "Consumer Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/booking.svg",
    "accent": "#003580"
  },
  {
    "ticker": "BLK",
    "name": "BlackRock, Inc.",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/blackrock.svg",
    "accent": "#000000"
  },
  {
    "ticker": "BRK-B",
    "name": "Berkshire Hathaway Inc. Class B",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/berkshire-hathaway.svg",
    "accent": "#003B70"
  },
  {
    "ticker": "BSX",
    "name": "Boston Scientific Corporation",
    "sector": "Health Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/boston-scientific.svg",
    "accent": "#0072CE"
  },
  {
    "ticker": "C",
    "name": "Citigroup Inc.",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/citigroup.svg",
    "accent": "#056DAE"
  },
  {
    "ticker": "CAT",
    "name": "Caterpillar Inc.",
    "sector": "Producer Manufacturing",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/caterpillar.svg",
    "accent": "#FFCD11"
  },
  {
    "ticker": "CI",
    "name": "Cigna Group",
    "sector": "Health Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/cigna.svg",
    "accent": "#003B71"
  },
  {
    "ticker": "CMG",
    "name": "Chipotle Mexican Grill, Inc.",
    "sector": "Consumer Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/chipotle-mexican-grill.svg",
    "accent": "#A6192E"
  },
  {
    "ticker": "COF",
    "name": "Capital One Financial Corp",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/capital-one.svg",
    "accent": "#D03027"
  },
  {
    "ticker": "COIN",
    "name": "Coinbase Global, Inc. Class A",
    "sector": "Finance",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/coinbase.svg",
    "accent": "#0052FF"
  },
  {
    "ticker": "COP",
    "name": "ConocoPhillips",
    "sector": "Energy Minerals",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/conocophillips.svg",
    "accent": "#E31837"
  },
  {
    "ticker": "COST",
    "name": "Costco Wholesale Corporation",
    "sector": "Retail Trade",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/costco-wholesale.svg",
    "accent": "#E31837"
  },
  {
    "ticker": "CRM",
    "name": "Salesforce, Inc.",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/salesforce.svg",
    "accent": "#032D60"
  },
  {
    "ticker": "CRWD",
    "name": "CrowdStrike Holdings, Inc. Class A",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/crowdstrike.svg",
    "accent": "#E01E3C"
  },
  {
    "ticker": "CSCO",
    "name": "Cisco Systems, Inc.",
    "sector": "Electronic Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/cisco.svg",
    "accent": "#049FD9"
  },
  {
    "ticker": "CVS",
    "name": "CVS Health Corporation",
    "sector": "Retail Trade",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/cvs-health.svg",
    "accent": "#CC0000"
  },
  {
    "ticker": "CVX",
    "name": "Chevron Corporation",
    "sector": "Energy Minerals",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/chevron.svg",
    "accent": "#0066B3"
  },
  {
    "ticker": "DASH",
    "name": "DoorDash, Inc. Class A",
    "sector": "Transportation",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/doordash.svg",
    "accent": "#FF3008"
  },
  {
    "ticker": "DDOG",
    "name": "Datadog, Inc. Class A",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/datadog.svg",
    "accent": "#632CA6"
  },
  {
    "ticker": "DIS",
    "name": "Walt Disney Company",
    "sector": "Consumer Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/walt-disney.svg",
    "accent": "#113CCF"
  },
  {
    "ticker": "DUK",
    "name": "Duke Energy Corporation",
    "sector": "Utilities",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/duke-energy.svg",
    "accent": "#005EB8"
  },
  {
    "ticker": "EL",
    "name": "Estee Lauder Companies Inc. Class A",
    "sector": "Consumer Non-Durables",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/estee-lauder.svg",
    "accent": "#000000"
  },
  {
    "ticker": "GE",
    "name": "GE Aerospace",
    "sector": "Electronic Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/ge-aerospace.svg",
    "accent": "#0875C1"
  },
  {
    "ticker": "GILD",
    "name": "Gilead Sciences, Inc.",
    "sector": "Health Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/gilead.svg",
    "accent": "#0072CE"
  },
  {
    "ticker": "GOOGL",
    "name": "Alphabet Inc. Class A",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/alphabet.svg",
    "accent": "#4285F4"
  },
  {
    "ticker": "GS",
    "name": "Goldman Sachs Group, Inc.",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/golden-sachs-etf-trust-goldman.svg",
    "accent": "#7399C6"
  },
  {
    "ticker": "HD",
    "name": "Home Depot, Inc.",
    "sector": "Retail Trade",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/home-depot.svg",
    "accent": "#F96302"
  },
  {
    "ticker": "HON",
    "name": "Honeywell International Inc.",
    "sector": "Producer Manufacturing",
    "exchange": "NASDAQ",
    "logoUrl": "",
    "accent": "#F47B20"
  },
  {
    "ticker": "HOOD",
    "name": "Robinhood Markets, Inc. Class A",
    "sector": "Finance",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/robinhood.svg",
    "accent": "#00C805"
  },
  {
    "ticker": "HUM",
    "name": "Humana Inc.",
    "sector": "Health Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/humana.svg",
    "accent": "#0072CE"
  },
  {
    "ticker": "IBM",
    "name": "International Business Machines Corporation",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/international-bus-mach.svg",
    "accent": "#0F62FE"
  },
  {
    "ticker": "INTC",
    "name": "Intel Corporation",
    "sector": "Electronic Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/intel.svg",
    "accent": "#0071C5"
  },
  {
    "ticker": "INTU",
    "name": "Intuit Inc.",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/intuit.svg",
    "accent": "#365EBF"
  },
  {
    "ticker": "ISRG",
    "name": "Intuitive Surgical, Inc.",
    "sector": "Health Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/intuitive-surgical.svg",
    "accent": "#0072CE"
  },
  {
    "ticker": "JNJ",
    "name": "Johnson & Johnson",
    "sector": "Health Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/johnson-and-johnson.svg",
    "accent": "#D51920"
  },
  {
    "ticker": "JPM",
    "name": "JPMorgan Chase & Co.",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/jpmorgan-chase.svg",
    "accent": "#117ACA"
  },
  {
    "ticker": "KO",
    "name": "Coca-Cola Company",
    "sector": "Consumer Non-Durables",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/coca-cola.svg",
    "accent": "#F40009"
  },
  {
    "ticker": "LIN",
    "name": "Linde plc",
    "sector": "Process Industries",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/linde.svg",
    "accent": "#005EB8"
  },
  {
    "ticker": "LLY",
    "name": "Eli Lilly and Company",
    "sector": "Health Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/eli-lilly.svg",
    "accent": "#D52B1E"
  },
  {
    "ticker": "LOW",
    "name": "Lowe's Companies, Inc.",
    "sector": "Retail Trade",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/lowe-s.svg",
    "accent": "#004990"
  },
  {
    "ticker": "LULU",
    "name": "lululemon athletica inc.",
    "sector": "Consumer Non-Durables",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/lululemon-athletica.svg",
    "accent": "#000000"
  },
  {
    "ticker": "LYFT",
    "name": "Lyft, Inc. Class A",
    "sector": "Transportation",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/lyft.svg",
    "accent": "#FF00BF"
  },
  {
    "ticker": "MA",
    "name": "Mastercard Incorporated Class A",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/mastercard.svg",
    "accent": "#EB001B"
  },
  {
    "ticker": "MCD",
    "name": "McDonald's Corporation",
    "sector": "Consumer Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/mcdonalds.svg",
    "accent": "#FFC72C"
  },
  {
    "ticker": "MDB",
    "name": "MongoDB, Inc. Class A",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/mongodb.svg",
    "accent": "#00ED64"
  },
  {
    "ticker": "MELI",
    "name": "MercadoLibre, Inc.",
    "sector": "Retail Trade",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/mercadolibre.svg",
    "accent": "#FFE600"
  },
  {
    "ticker": "META",
    "name": "Meta Platforms Inc Class A",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/meta-platforms.svg",
    "accent": "#0866FF"
  },
  {
    "ticker": "MRK",
    "name": "Merck & Co., Inc.",
    "sector": "Health Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/merck-and-co.svg",
    "accent": "#007A33"
  },
  {
    "ticker": "MS",
    "name": "Morgan Stanley",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/morgan-stanley.svg",
    "accent": "#002C5F"
  },
  {
    "ticker": "MSFT",
    "name": "Microsoft Corporation",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/microsoft.svg",
    "accent": "#5E5E5E"
  },
  {
    "ticker": "NEE",
    "name": "NextEra Energy, Inc.",
    "sector": "Utilities",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/nextera-energy.svg",
    "accent": "#00AEEF"
  },
  {
    "ticker": "NET",
    "name": "Cloudflare Inc Class A",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/cloudflare-inc.svg",
    "accent": "#F38020"
  },
  {
    "ticker": "NFLX",
    "name": "Netflix, Inc.",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/netflix.svg",
    "accent": "#E50914"
  },
  {
    "ticker": "NKE",
    "name": "NIKE, Inc. Class B",
    "sector": "Consumer Non-Durables",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/nike.svg",
    "accent": "#111111"
  },
  {
    "ticker": "NOW",
    "name": "ServiceNow, Inc.",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/servicenow.svg",
    "accent": "#81B5A1"
  },
  {
    "ticker": "NVDA",
    "name": "NVIDIA Corporation",
    "sector": "Electronic Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/nvidia.svg",
    "accent": "#76B900"
  },
  {
    "ticker": "ORCL",
    "name": "Oracle Corporation",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/oracle.svg",
    "accent": "#F80000"
  },
  {
    "ticker": "OXY",
    "name": "Occidental Petroleum Corporation",
    "sector": "Energy Minerals",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/occidental-petroleum.svg",
    "accent": "#003DA5"
  },
  {
    "ticker": "PANW",
    "name": "Palo Alto Networks, Inc.",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/palo-alto-networks.svg",
    "accent": "#FA582D"
  },
  {
    "ticker": "PEP",
    "name": "PepsiCo, Inc.",
    "sector": "Consumer Non-Durables",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/pepsico.svg",
    "accent": "#004B93"
  },
  {
    "ticker": "PG",
    "name": "Procter & Gamble Company",
    "sector": "Consumer Non-Durables",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/procter-and-gamble.svg",
    "accent": "#003DA5"
  },
  {
    "ticker": "PLD",
    "name": "Prologis, Inc.",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/prologis.svg",
    "accent": "#005596"
  },
  {
    "ticker": "PLTR",
    "name": "Palantir Technologies Inc. Class A",
    "sector": "Technology Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/palantir.svg",
    "accent": "#101820"
  },
  {
    "ticker": "PYPL",
    "name": "PayPal Holdings, Inc.",
    "sector": "Commercial Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/paypal.svg",
    "accent": "#003087"
  },
  {
    "ticker": "QCOM",
    "name": "QUALCOMM Incorporated",
    "sector": "Electronic Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/qualcomm.svg",
    "accent": "#3253DC"
  },
  {
    "ticker": "RDDT",
    "name": "Reddit, Inc. Class A",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/reddit.svg",
    "accent": "#FF4500"
  },
  {
    "ticker": "REGN",
    "name": "Regeneron Pharmaceuticals, Inc.",
    "sector": "Health Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/regeneron-pharmaceuticals.svg",
    "accent": "#003B5C"
  },
  {
    "ticker": "RTX",
    "name": "RTX Corporation",
    "sector": "Electronic Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/raytheon.svg",
    "accent": "#002D62"
  },
  {
    "ticker": "SBUX",
    "name": "Starbucks Corporation",
    "sector": "Consumer Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/starbucks.svg",
    "accent": "#00704A"
  },
  {
    "ticker": "SCHW",
    "name": "Charles Schwab Corp",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/schwab.svg",
    "accent": "#00A0DF"
  },
  {
    "ticker": "SHOP",
    "name": "Shopify, Inc. Class A",
    "sector": "Commercial Services",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/shopify.svg",
    "accent": "#95BF47"
  },
  {
    "ticker": "SLB",
    "name": "SLB Limited",
    "sector": "Industrial Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/schlumberger.svg",
    "accent": "#0072CE"
  },
  {
    "ticker": "SNOW",
    "name": "Snowflake, Inc.",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/snowflake.svg",
    "accent": "#29B5E8"
  },
  {
    "ticker": "SO",
    "name": "Southern Company",
    "sector": "Utilities",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/southern.svg",
    "accent": "#00AEEF"
  },
  {
    "ticker": "SPG",
    "name": "Simon Property Group, Inc.",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/simon-property.svg",
    "accent": "#005EB8"
  },
  {
    "ticker": "SPOT",
    "name": "Spotify Technology SA",
    "sector": "Technology Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/spotify-technology.svg",
    "accent": "#1DB954"
  },
  {
    "ticker": "TGT",
    "name": "Target Corporation",
    "sector": "Retail Trade",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/target.svg",
    "accent": "#CC0000"
  },
  {
    "ticker": "TJX",
    "name": "TJX Companies Inc",
    "sector": "Retail Trade",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/tjx-cos.svg",
    "accent": "#E31837"
  },
  {
    "ticker": "TMO",
    "name": "Thermo Fisher Scientific Inc.",
    "sector": "Health Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/thermo-fisher-scientific.svg",
    "accent": "#007C91"
  },
  {
    "ticker": "TSLA",
    "name": "Tesla, Inc.",
    "sector": "Consumer Durables",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/tesla.svg",
    "accent": "#E82127"
  },
  {
    "ticker": "TXN",
    "name": "Texas Instruments Incorporated",
    "sector": "Electronic Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/texas-instruments.svg",
    "accent": "#CC0000"
  },
  {
    "ticker": "UBER",
    "name": "Uber Technologies, Inc.",
    "sector": "Transportation",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/uber.svg",
    "accent": "#000000"
  },
  {
    "ticker": "UNH",
    "name": "UnitedHealth Group Incorporated",
    "sector": "Health Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/unitedhealth.svg",
    "accent": "#002677"
  },
  {
    "ticker": "UNP",
    "name": "Union Pacific Corporation",
    "sector": "Transportation",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/union-pacific.svg",
    "accent": "#005DAA"
  },
  {
    "ticker": "USB",
    "name": "U.S. Bancorp",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/us-bancorp.svg",
    "accent": "#005EB8"
  },
  {
    "ticker": "V",
    "name": "Visa Inc. Class A",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/visa.svg",
    "accent": "#1A1F71"
  },
  {
    "ticker": "VRTX",
    "name": "Vertex Pharmaceuticals Incorporated",
    "sector": "Health Technology",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/vertex-pharmaceutical.svg",
    "accent": "#00857C"
  },
  {
    "ticker": "WFC",
    "name": "Wells Fargo & Company",
    "sector": "Finance",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/wells-fargo.svg",
    "accent": "#D71E28"
  },
  {
    "ticker": "WMT",
    "name": "Walmart Inc.",
    "sector": "Retail Trade",
    "exchange": "NASDAQ",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/walmart.svg",
    "accent": "#0071CE"
  },
  {
    "ticker": "XOM",
    "name": "Exxonmobil Holdings Corporation",
    "sector": "Energy Minerals",
    "exchange": "NYSE",
    "logoUrl": "",
    "accent": "#ED1C24"
  },
  {
    "ticker": "YUM",
    "name": "Yum! Brands, Inc.",
    "sector": "Consumer Services",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/yum-brands.svg",
    "accent": "#E31837"
  },
  {
    "ticker": "ZTS",
    "name": "Zoetis, Inc. Class A",
    "sector": "Health Technology",
    "exchange": "NYSE",
    "logoUrl": "https://s3-symbol-logo.tradingview.com/zoetis.svg",
    "accent": "#0072CE"
  }
];
